import template from './message.html'
import css from './message.css'
import { MessageController } from './message.controller.js'

export const MessageComponent = {
  template: template,
  controller: MessageController,
  controllerAs: 'MessageController',
  transclude: true,
  bindings: {
    resource: '=',
    panel:'@'
  },
  require: {
    parentSimulator: '^^simulatorComponent'
  }
}



// WEBPACK FOOTER //
// ./src/client/common/uiComponents/Message/message.component.js